import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, MenuItem, Modal, Paper, Select, Skeleton, Stack, Switch, TextField, Typography } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ImagePoster from "../../components/Cards/ImagePoster";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import ProductDetailsCarousel from "../../components/Carousel/ProductDetailsCarousel";
import axios from "axios";
import { MarketPlaceStyle } from "../../styles/common.styles";
import "react-multi-carousel/lib/styles.css";
import { makeStyles, styled } from "@mui/styles";
import Pagination from "@mui/material/Pagination";
import TostMessagesTop from "../../Component/Toast";
import "./Carousel.css";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import Nodataimgur from "../../assets/Images/datanotfound/NoDataFoundWithLogo.png";
import { useNavigate } from "react-router-dom";
import DiscountPrice from "../../views/DiscountPrice";
import StacsOfCoinIcon from "../../assets/BXITokenIcon.png";
import readystock from "../../assets/Images/MarketplaceImages/ReadyStocknew.svg";
import bestseller from "../../assets/Images/MarketplaceImages/BestSellernew.svg";
import AndhraPradeshStateIcon from "../../assets/Images/States/Andhra.png";
import ArunachalPradeshIcon from "../../assets/Images/States/ArunachalPradesh.png";
import AssamIcon from "../../assets/Images/States/Assam.png";
import BiharStateIcon from "../../assets/Images/States/Bihar.png";
import ChhattisgarhStateIcon from "../../assets/Images/States/Chhattisgarh.png";
import GoaIcon from "../../assets/Images/States/Goa.png";
import GujaratStateIcon from "../../assets/Images/States/Gujarat.png";
import HimachalPradeshIcon from "../../assets/Images/States/HP.png";
import HaryanaIcon from "../../assets/Images/States/Haryana.png";
import JammuKashmirIcon from "../../assets/Images/States/J&K.png";
import JharkhandStateIcon from "../../assets/Images/States/Jharkhand.png";
import KarnatakaStateIcon from "../../assets/Images/States/Karnataka.png";
import KeralaStateIcon from "../../assets/Images/States/Kerala.png";
import MadhyaPradeshStateIcon from "../../assets/Images/States/MP.png";
import MaharastraStateIcon from "../../assets/Images/States/Maharashtra.png";
import ManipurIcon from "../../assets/Images/States/Manipur.png";
import MeghalayaIcon from "../../assets/Images/States/Meghalaya.png";
import MizoramIcon from "../../assets/Images/States/Mizoram.png";
import NagalandIcon from "../../assets/Images/States/Nagaland.png";
import OdishaStateIcon from "../../assets/Images/States/Odisha.png";
import PunjabIcon from "../../assets/Images/States/Punjab.png";
import RajasthanStateIcon from "../../assets/Images/States/Rajasthan.png";
import SikkimIcon from "../../assets/Images/States/Sikkim.png";
import TamilNaduStateIcon from "../../assets/Images/States/TamilNadu.png";
import TripuraIcon from "../../assets/Images/States/Tripura.png";
import UttarPradeshStateIcon from "../../assets/Images/States/UP.png";
import UttarakhandIcon from "../../assets/Images/States/Uttrakhand.png";
import WestBengalStateIcon from "../../assets/Images/States/WestBengal.png";
import TelanganaStateIcon from "../../assets/Images/States/telanganaStateIcon.png";
import sendEvent from "../../utils/sendEvents";
import BXIToken from "../../assets/BXITokenIcon.png";
import CommaSeparator from "../../views/CommaSeprator";
import Slider from "@mui/material/Slider";
import { Autocomplete } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CheckIcon from "@mui/icons-material/Check";
import StateData from "../../utils/StateCityArray.json";
// import DemoScheduler from "./DemoScheduler";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { toast, ToastContainer } from "react-toastify";
import GlobalToast from "../../components/Toasts/GlobalToast";
import { holidays } from "../../utils/holidaysList";
import { isSunday, format } from 'date-fns';



const StateObjectArray = [
  { Img: MaharastraStateIcon, text: "Maharashtra" },
  { Img: RajasthanStateIcon, text: "Rajasthan" },
  { Img: GujaratStateIcon, text: "Gujarat" },
  { Img: MadhyaPradeshStateIcon, text: "Madhya Pradesh" },
  { Img: KarnatakaStateIcon, text: "Karnataka" },
  { Img: UttarPradeshStateIcon, text: "Uttar Pradesh" },
  { Img: TamilNaduStateIcon, text: "Tamil Nadu" },
  { Img: AndhraPradeshStateIcon, text: "Andhra Pradesh" },
  { Img: TelanganaStateIcon, text: "Telangana" },
  { Img: KeralaStateIcon, text: "Kerala" },
  { Img: WestBengalStateIcon, text: "West Bengal" },
  { Img: OdishaStateIcon, text: "Odisha" },
  { Img: JharkhandStateIcon, text: "Jharkhand" },
  { Img: BiharStateIcon, text: "Bihar" },
  { Img: ChhattisgarhStateIcon, text: "Chhattisgarh" },
  { Img: ArunachalPradeshIcon, text: "Arunachal Pradesh" },
  { Img: AssamIcon, text: "Assam" },
  { Img: ManipurIcon, text: "Manipur" },
  { Img: MeghalayaIcon, text: "Meghalaya" },
  { Img: MizoramIcon, text: "Mizoram" },
  { Img: NagalandIcon, text: "Nagaland" },
  { Img: SikkimIcon, text: "Sikkim " },
  { Img: TripuraIcon, text: "Tripura" },
  { Img: HaryanaIcon, text: "Haryana" },
  { Img: PunjabIcon, text: "Punjab" },
  { Img: JammuKashmirIcon, text: "Jammu & Kashmir" },
  { Img: HimachalPradeshIcon, text: "Himachal Pradesh" },
  { Img: UttarakhandIcon, text: "Uttarakhand" },
  { Img: GoaIcon, text: "Goa" },
];

function DiscountedPrice(regularPrice, gst, type) {
  const gstPrice = regularPrice / (1 + gst / 100);

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "row",
          width: "auto",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "14px",
            letterSpacing: "0.06em",
            textTransform: "capitalize",
            color: "#2261A2",
          }}
        >
          {type === "Media"
            ? Number(regularPrice).toFixed(2)
            : Number(gstPrice).toFixed(2)}
        </Typography>
      </Box>
    </div>
  );
}


function GstWithoutDiscountedPrice({ price, gst, listing }) {
  const priceWithoutGST = price / (1 + gst / 100);

  const gstAmount = price - priceWithoutGST;

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "row",
          width: "auto",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "14px",
            letterSpacing: "0.06em",
            textTransform: "capitalize",
            color: "#2261A2",
          }}
        >
          {Number(gstAmount).toFixed(2)}
        </Typography>
      </Box>
    </div>
  );
}

function MediaGstWithoutDiscountedPrice({ price, gst, listing }) {
  const gstAmount = (price * gst) / 100; // GST on top of base price

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "row",
          width: "auto",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "14px",
            letterSpacing: "0.06em",
            textTransform: "capitalize",
            color: "#2261A2",
          }}
        >
          {gstAmount.toFixed(2)}{" "}
        </Typography>
      </Box>
    </div>
  );
}


const useStyles = makeStyles((theme) => ({
  searchContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    mx: "auto",
  },
  searchInput: {
    marginRight: 2,
  },
  filterButton: {
    marginLeft: 2,
  },
  select: {
    minWidth: 120,
  },
  largerIcon: {
    fontSize: 24
  },
}));


const MarketPlace = () => {
  const classes = useStyles();

  const StyledPagination = styled(Pagination)({
    "& .MuiPaginationItem-root": {
      color: "#1976d2",
    },

    "& .MuiPaginationItem-root.Mui-selected": {
      color: "#fff",
    },
    "& .MuiPagination-ul li:last-child": {
      marginLeft: "16px",
    },
    "& .css-1v2lvtn-MuiPaginationItem-root": {
      marginRight: "16px",
      border: "none !important",
    },
    "& .MuiPagination-ul li:last-child": {
      marginLeft: "16px",
    },
    "& .MuiPagination-ul li:last-child button::before": {
      content: "'Next'",
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 800,
      fontSize: "11px",
      lineHeight: "14px",
      color: "#445FD2",
      marginRight: "8px",
    },
    "& .MuiPagination-ul li:first-child": {
      marginRight: "16px",
    },
    "& .MuiPagination-ul li:last-child button::before": {
      content: "'Next'",
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 800,
      fontSize: "11px",
      lineHeight: "14px",
      color: "#445FD2",
      marginRight: "8px",
    },
    "& .MuiPagination-ul li:first-child": {
      marginRight: "16px",
    },
    "& .MuiPagination-ul li:first-child button::after": {
      content: "'Previous'",
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 800,
      fontSize: "11px",
      lineHeight: "14px",
      color: "#445FD2",
      marginLeft: "8px",
    },
    "& .MuiPaginationItem-icon": {
      color: "#445FD2",
      fontWeight: 800,
    },
  });

  const inputRef = useRef();
  const [currentPage, setcurrentPage] = useState(1)
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
  const [pricerange, setPriceRange] = useState(1000000);
  const [open, setOpen] = React.useState(false);
  const [isBestSeller, setIsBestSeller] = useState(false);
  const [IsReadyStock, setIsReadyStock] = useState(false);
  const [carouselData, setCarouselData] = useState("");
  const [taxSwitch, setTaxSwitch] = useState(false);
  const [productdataLoading, setProductDataLoading] = useState(true)
  const [CompanyTypeData, setCompanyTypeData] = useState([])
  const [sortby, setSortby] = React.useState("");
  const [ProductLocationState, setstatefilter] = useState([]);
  const [priceShortHightToLow, setPriceShortHightToLow] = useState(false);
  const [priceShortLowToHight, setPriceShortLowToHight] = useState(false);
  const [AllProducts, setAllProducts] = useState([])
  const [initialPaginationCount, setInitialPaginationCount] = useState(1);
  const [FilterType, setFilterType] = useState('all')
  const [mediaFilter, setMediaFilter] = useState('')
  const [productFilter, setProductsFilter] = useState('')
  const [voucher, setVoucher] = useState('')
  const [all, setAll] = useState(true)
  const [ProductQty, setProductQty] = useState("");
  const [clear, setClear] = useState("");
  const [stateArray, setStateArray] = useState();
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [CityArray, setCityArray] = useState([]);
  const [allProductSearch, setAllProductSearch] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [MediaSubCategory, setMediaSubCatArr] = useState([])
  const [MediaSubCategoryId, setMediaSubCatArrId] = useState('')
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCities, setFilteredCities] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [handleOpenDemo, setHandleOpenDemo] = useState(false)

  // demo schedule
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', company: '' });
  const [errors, setErrors] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [loadingSlots, setLoadingSlots] = useState(false);

  // search 
  const handleStyleChange = () => {
    inputRef.current.style.color = "#C3CAD9";
    inputRef.current.style.fontSize = "14px";
    inputRef.current.style.fontFamily = "Poppins";
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  };

  const debouncedSearchChange = useCallback(
    debounce((value) => setDebouncedSearch(value), 500),
    []
  );

  useEffect(() => {
    if (search !== undefined) {
      debouncedSearchChange(search);
    }
  }, [search, debouncedSearchChange]);


  const handleCarouselData = (data) => {
    setCarouselData(data);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getCompanyType = async () => {
    return await axios
      .get("company_type/get_companyTypes")
      .then((res) => {
        setCompanyTypeData(res?.data)
      })
      .catch((err) => { });
  };
  useEffect(() => {
    getCompanyType();
  }, []);

  const GetCompanyData = async () => {
    try {
      await axios
        .get(`auth/getauthsCompany`, { withCredentials: true })
        .then((res) => {
          GetCompanyTypeData(res?.data?.companyType);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const GetCompanyTypeData = async (props) => {
    try {
      await axios.get(`company_type/get_companyType/${props}`).then((res) => {
        localStorage.setItem("companyType", res?.data?.CompanyTypeName);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    GetCompanyData();
  }, []);


  window.onload = () => {
    setRefresh(true);
  };

  const filterByCompany = async () => {
    await axios
      .get(`product/get_allproducts_bycompany`, { withCredentials: true })
      .then((res) => {
        setAllProductSearch(res.data);
      })
      .catch((err) => { });
  };

  useEffect(() => {
    filterByCompany();
  }, []);


  const handlePageChange = useCallback(
    (event, page) => {
      setcurrentPage(page);
    },
    []
  );

  let IsReadyStockflatIdsArray = null;
  if (IsReadyStock?.length > 0) {
    const IsReadyStockproductsArrayFilter =
      IsReadyStock && IsReadyStock?.filter((item) => item._status === true);

    IsReadyStockflatIdsArray = IsReadyStockproductsArrayFilter?.map(
      (item) => item._product_id
    );
  }

  const handleSearchTypeChange = (event) => {
    setFilterType(event.target.value);
    let type = event.target.value;
    if (type === "media") {
      setMediaFilter(true);
      setProductsFilter(false);
      setVoucher(false);
      handleClose();
      sendEvent("Click on product icon");
      setAll(false);
    } else if (type === "product") {
      setMediaFilter(false);
      setProductsFilter(true);
      setVoucher(false);
      handleClose();
      setAll(false);
      sendEvent("Click on product icon");
    } else if (type === "voucher") {
      setMediaFilter(false);
      setProductsFilter(false);
      setVoucher(true);
      handleClose();
      setAll(false);
      sendEvent("Click on product icon");
    } else if (type === "all") {
      setMediaFilter(false);
      setProductsFilter(false);
      setVoucher(false);
      handleClose();
      setAll(true);
      sendEvent("Click on clear filter");
      handleClearFilter()
    }
  };

  const handleSwitch = () => {
    if (!taxSwitch) {
      setTaxSwitch(true);
    } else {
      setTaxSwitch(false);
    }
  };

  const handleChange = ({ target: { value } }) => {
    setSortby(value);
    const states = {
      "": {
        isBestSeller: false,
        isReadyStock: false,
        priceShortHightToLow: false,
        priceShortLowToHight: false,
      },
      isReadyStock: { isReadyStock: true },
      isBestSeller: { isBestSeller: true },
      priceShortHightToLow: { priceShortHightToLow: true },
      priceShortLowToHight: { priceShortLowToHight: true },
    };

    const newState = states[value] || states[""];
    setIsBestSeller(newState.isBestSeller || false);
    setIsReadyStock(newState.isReadyStock || false);
    setPriceShortHightToLow(newState.priceShortHightToLow || false);
    setPriceShortLowToHight(newState.priceShortLowToHight || false);
  };

  const FetchAllProducts = async (productsFilter, mediaFilter, voucher, all, debouncedSearch, sortby, ProductLocationState, pricerange, selectedCompany, carouselData, currentPage, MediaSubCategoryId, city) => {
    try {
      setProductDataLoading(true)
      await axios.post(`product/get_products_explore`, {
        productsFilter: productsFilter,
        mediaFilter: mediaFilter,
        Voucher: voucher,
        all: all,
        debouncedSearch: debouncedSearch,
        sortby: sortby,
        ProductLocationState: ProductLocationState,
        pricerange: pricerange,
        selectedCompany: selectedCompany,
        ProductCategory: carouselData,
        currentPage: currentPage,
        MediaSubCategoryId: MediaSubCategoryId,
        city: city
      }).then((response) => {
        setProductDataLoading(false)
        setAllProducts(response?.data?.products)
        setInitialPaginationCount(response?.data?.count)
      }).catch((error) => {
      })
    } catch (error) {

    }
  }

  const handleSearch = (event, newValue) => {
    setSelectedCompany(newValue);
    const uniqueCompanyNames = AllProducts
      ?.map((option) => option?.SellerCompanyId?.companyName || "")
      ?.filter(Boolean);
    const filteredResults = uniqueCompanyNames?.filter((name) =>
      name.toLowerCase().includes(newValue?.toLowerCase())
    );
  };


  useEffect(() => {
    FetchAllProducts(productFilter, mediaFilter, voucher, all, debouncedSearch, sortby, ProductLocationState, pricerange, selectedCompany, carouselData, currentPage, MediaSubCategoryId, city)
  }, [all, FilterType, productFilter, mediaFilter, voucher, debouncedSearch, sortby, ProductLocationState, pricerange, selectedCompany, carouselData, currentPage, MediaSubCategoryId, city])


  useEffect(() => {
    const fetchBestSeller = async () => {
      try {
        await axios.get("AdminCompanyDetails/BestSeller");
      } catch (error) {
        console.error("Failed to fetch best sellers", error);
      }
    };

    const fetchReadyStock = async () => {
      try {
        await axios.get(
          "wallet/get_all_credit_line_transaction"
        );
        setIsReadyStock(data.body);
      } catch (error) {
        console.error("Failed to fetch ready stock", error);
      }
    };

    fetchBestSeller();
    fetchReadyStock();
  }, []);

  const handleClearFilter = () => [
    setAll(true),
    setMediaFilter(false),
    setProductsFilter(false),
    setVoucher(false),
    setFilterType('all'),
    setPriceShortHightToLow(false),
    setPriceShortLowToHight(false),
    setIsBestSeller(false),
    setIsReadyStock(false),
    setDebouncedSearch(''),
    setSortby(''),
    setstatefilter([]),
    setSelectedCompany(''),
    setPriceRange(1000000),
    setcurrentPage(1),
    setOpen(false),
    setMediaSubCatArrId(''),
    setClear(true),
    setSearch('')
  ]

  const fetchMediaSubCategories = async () => {
    await axios
      .get("mediaonlineoffline_sub/Get_media_offline_online_subcategories", {
        withCredentials: true,
      })
      .then((res) => {
        setMediaSubCatArr(res?.data);
      })
      .catch((err) => { });
  };
  useEffect(() => {
    fetchMediaSubCategories();
  }, []);

  const handleSelectMediaSubCategory = (e) => {
    setMediaSubCatArrId(e)
  }

  useEffect(() => {
    const isMediaSelected = FilterType === "media";
    const isMediaCategorySelected = carouselData?.length === 1 && carouselData?.[0] === "63e38b91cc4c02b8a0c94b69";

    if (!isMediaSelected && !isMediaCategorySelected) {
      setMediaSubCatArrId('');
    }
  }, [carouselData, FilterType]);

  useEffect(() => {
    if (ProductLocationState?.length > 0) {
      let cities = StateData
        ?.filter((state) => ProductLocationState?.includes(state.name))
        .flatMap((state) => state.data);

      setCityArray([...new Set(cities)]);
    } else {
      setCityArray([]);
    }
  }, [ProductLocationState]);


  useEffect(() => {
    if (searchQuery) {
      const filtered = CityArray.filter((city) =>
        city.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredCities(filtered);

      if (filtered.length === 1) {
        setCity(filtered[0]);
      }
    } else {
      setFilteredCities(CityArray);
    }
  }, [searchQuery, CityArray]);


  const toCamelCase = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .replace(/\s+/g, " ");
  };


  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      const scrollPercentage = (scrollTop + windowHeight) / fullHeight;
      if (scrollPercentage >= 0.9 && !hasSubmitted) {
        const localstoragedata = localStorage.getItem("demoschedular")
        if (localstoragedata !== "booked") {
          setShowPopup(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasSubmitted]);

  const fetchSlots = async (date) => {
    setLoadingSlots(true);
    setSelectedSlot(null);
    try {
      const res = await axios.get(`https://production-api.unada.in/demoschedular/slots?date=${date.toISOString().split('T')[0]}`)?.then((response) => {
        setAvailableSlots(response?.data);
      })
    } catch (err) {
    } finally {
      setLoadingSlots(false);
    }
  };

  useEffect(() => {
    fetchSlots(selectedDate);
  }, [selectedDate]);

  const handleChangeFormdata = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10,11}$/;
    const restrictedDomains = ['gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com'];

    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.company) newErrors.company = 'Company is required';
    if (!formData.email || !emailRegex.test(formData.email)) {
      newErrors.email = 'Valid email is required';
    } else if (restrictedDomains.some(domain => formData.email.endsWith(`@${domain}`))) {
      newErrors.email = 'Use business email address';
    }
    if (!formData.phone || !phoneRegex.test(formData.phone)) {
      newErrors.phone = 'Valid phone number required';
    }
    if (!selectedSlot) newErrors.slot = 'Please select a time slot';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    await axios.post('https://production-api.unada.in/demoschedular/book', {
      ...formData,
      scheduledAt: selectedSlot,
    }).then((response) => {
      if (response?.data?.booking?.scheduledAt) {
        toast.success(`Your demo is successfully booked on ${new Date(response?.data?.booking?.scheduledAt)?.toLocaleTimeString()}`), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
        localStorage.setItem("demoschedular", "booked")
        setShowPopup(false)
        setHasSubmitted(true);
      }
    })
  };


  return (
    <Paper
      sx={{
        width: "92%",
        mx: "auto",
        background: "#f3f6f9",
        borderRadius: "5px",
      }}
      elevation={0}
    >

      <ToastContainer style={{ fontSize: "16px" }} />
      <Box sx={MarketPlaceStyle.BoxStyle}>
        <Paper
          elevation={0}
          sx={{
            width: "89%",
            mx: "auto",
            boxShadow: "none",
            background: "#f3f6f9",
            display: "flex",
            gap: "20px",
            position: "fixed",
            marginTop: "10px",
            height: "80px",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              alignContent: "center",
              width: "100%",
              maxWidth: "80%",
              mx: "auto",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                width: "80%",
                border: "none",
                height: "45px",
                borderRadius: "25px",
                background: "#fff",
                p: 0,
                display: "flex",
                boxShadow: "#2261a2 0px 0px 0px 0.5px;",
              }}
            >
              <Box
                sx={{
                  width: "15%",
                  bgcolor: "transparent",
                  borderRight: "2px solid #dee2e6",
                }}
              >
                <Select
                  select
                  label="Search Type"
                  defaultValue="All"
                  value={FilterType}
                  onChange={handleSearchTypeChange}
                  variant="standard"
                  disableUnderline
                  className={classes.searchInput}
                  IconComponent={() => (
                    <ArrowDropDownIcon
                      className={classes.largerIcon}
                      fontSize="larger"
                    />
                  )}
                  sx={{
                    width: "100%",
                    maxWidth: "110px",
                    border: "none",
                    outline: "none",
                    height: "100%",
                    background: "transparent",
                    margin: "10px",
                    color: "#2261A2",
                    fontSize: "15px",
                    marginLeft: "17px",
                    marginTop: "0px",
                  }}
                >
                  <MenuItem value="all" sx={{ color: "#2261A2" }}>
                    All
                  </MenuItem>
                  <MenuItem value="product" sx={{ color: "#2261A2" }}>
                    Product
                  </MenuItem>
                  <MenuItem value="media" sx={{ color: "#2261A2" }}>
                    Media
                  </MenuItem>
                  <MenuItem value="voucher" sx={{ color: "#2261A2" }}>
                    Voucher
                  </MenuItem>
                </Select>
              </Box>
              <Box
                sx={{
                  background: "#fff",
                  width: "4%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <SearchIcon fontSize="large" color="disabled" />
              </Box>

              <input
                onClick={() => {
                  handleStyleChange();
                }}
                ref={inputRef}
                onChange={handleSearchChange}
                label="Search"
                placeholder="Search"
                value={search}
                variant="outlined"
                InputProps={{ disableUnderline: true }}
                style={{
                  color: "#2261a2",
                  width: "75%",
                  boxShadow: "none",
                  border: "none",
                  height: "93%",
                  fontSize: "16px",
                }}
              />
              <Button
                variant="contained"
                color="primary"
                sx={{
                  height: "100%",
                  width: "4.5%",
                  mr: "05px",
                  borderRadius: "0px 27px 27px 0px",
                  background: "#fff",
                  width: "50px",
                  border: "none",
                  marginTop: "0px",
                  boxShadow: "none",
                  ":hover": {
                    background: "#fff",
                    boxShadow: "none",
                  },
                }}
                onClick={() => {
                  handleOpen();
                  sendEvent("Click on filter");
                }}
                disableRipple
                disableFocusRipple
                disableTouchRipple
              >
                <TuneIcon fontSize="large" color="primary" />
              </Button>

              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={FilterModalStyle}>

                  {(carouselData?.includes("63e38b91cc4c02b8a0c94b69") || (FilterType === "media")) && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        alignContent: "center",
                        mt: 3,
                        height: "auto",
                        display: "grid",
                        flexDirection: "row",
                        width: "80%",
                        bgcolor: "transparent",
                        mx: "auto",
                        boxShadow: "none",

                      }}
                    >
                      <Typography sx={{ ...FilterTitle, cursor: "default" }}>
                        Subcategory
                      </Typography>
                      <select onChange={(e) => {
                        handleSelectMediaSubCategory(e.target.value)
                      }}
                        style={{
                          width: "100%",
                          padding: "8px",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          color: "#2E2E2E",
                          fontWeight: 500,
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                          backgroundColor: "#fff",
                          outline: "none",
                          cursor: "pointer",
                          minWidth: "345px",
                          marginTop: "10px"
                        }}

                      >
                        <option value="">
                          Please select
                        </option>
                        {MediaSubCategory?.map((response) => {
                          return (
                            <option value={response?._id} style={{
                              width: "100%",
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              textDecoration: "Camelcase"

                            }}>{toCamelCase(
                              response?.Mediaonlinecategorysingle || response?.Mediaofflinecategory
                            )}</option>
                          )
                        })}
                      </select>
                    </Box>
                  )}
                  <Paper
                    elevation={0}
                    sx={{
                      width: "80%",
                      bgcolor: "transparent",
                      mx: "auto",
                      boxShadow: "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        alignContent: "center",
                        mt: 1,
                        height: "50px",
                      }}
                    >
                      <Typography sx={{ ...FilterTitle, cursor: "default" }}>
                        Sort by
                      </Typography>
                    </Box>
                    <FormControl sx={{ width: "100%" }}>
                      <Select
                        value={sortby}
                        onChange={handleChange}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={{ width: "100%" }}
                      >
                        <MenuItem value="">
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "13px",
                              color: "#2E2E2E",
                              fontWeight: 500,
                            }}
                          >
                            Default
                          </Typography>
                        </MenuItem>
                        <MenuItem value={"priceShortLowToHight"}>
                          {" "}
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "13px",
                              color: "#2E2E2E",
                              fontWeight: 500,
                            }}
                          >
                            Price (Low to High)
                          </Typography>
                        </MenuItem>
                        <MenuItem value={"priceShortHightToLow"}>
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "13px",
                              color: "#2E2E2E",
                              fontWeight: 500,
                            }}
                          >
                            Price (High to Low)
                          </Typography>
                        </MenuItem>

                        <MenuItem value={"isReadyStock"}>
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "13px",
                              color: "#2E2E2E",
                              fontWeight: 500,
                            }}
                          >
                            ReadyStock
                          </Typography>
                        </MenuItem>
                        <MenuItem value={"isBestSeller"}>
                          <Typography
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "13px",
                              color: "#2E2E2E",
                              fontWeight: 500,
                            }}
                          >
                            BestSeller
                          </Typography>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Paper>

                  {!voucher && (<>
                    <Paper
                      elevation={0}
                      sx={{
                        width: "80%",
                        bgcolor: "transparent",
                        mx: "auto",
                        boxShadow: "none",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          alignContent: "center",
                          mt: 0,
                          height: "50px",
                        }}
                      >
                        <Typography sx={{ ...FilterTitle, cursor: "default" }}>
                          Location
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          alignContent: "center",
                          height: "0px",
                        }}
                      ></Box>
                      <Box
                        sx={{
                          width: "100%",
                          height: "110px",
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          alignContent: "center",
                          maxWidth: "385px",

                          overflow: "auto",
                          "::-webkit-scrollbar": {
                            display: "flex",
                            height: "6px",
                          },
                          gap: "10px",
                          mt: 0,
                          cursor: "pointer",
                        }}
                      >
                        {StateObjectArray?.map((res, idx) => {
                          return (
                            <Box
                              key={idx}
                              onClick={() => {
                                if (ProductLocationState.includes(res.text)) {
                                  setstatefilter(
                                    ProductLocationState.filter(
                                      (item) => item !== res.text
                                    )
                                  );
                                } else {
                                  setstatefilter([...ProductLocationState, res.text]);
                                }

                                setStateArray(res.text);
                                setState(res.text);
                              }}
                              sx={{
                                width: "100%",
                                minWidth: "90px",
                                height: "90px",
                                display: "grid",
                                justifyContent: "center",
                                alignItems: "center",
                                alignContent: "center",
                                borderRadius: "12px",
                                bgcolor: "rgba(243, 246, 249, 0.6)",
                                position: "relative",
                                border: "0.1px solid transparent",
                                "&:hover": {
                                  border: "0.1px solid #445FD2",
                                  boxShadow:
                                    "inset 4px -4px 4px rgba(246, 246, 246, 0.25), inset -4px 4px 4px rgba(246, 246, 246, 0.25)",
                                },
                              }}
                            >
                              {ProductLocationState.includes(res.text) ? (
                                <CheckIcon
                                  onClick={() => {
                                    sendEvent("Click on check button");
                                  }}
                                  sx={{
                                    position: "absolute",
                                    marginBottom: "7rem",
                                    marginLeft: "7rem",
                                    fontSize: "12px",
                                    padding: "4px",
                                    color: "#445FD2",
                                    background: "#FFFFFF",
                                    border: "2px solid rgba(206, 206, 206, 0.5)",
                                    boxShadow:
                                      "inset 4px -4px 4px rgba(246, 246, 246, 0.25), inset -4px 4px 4px rgba(246, 246, 246, 0.25)",
                                    borderRadius: 100,
                                  }}
                                />
                              ) : null}
                              <Box>
                                <img
                                  src={res.Img}
                                  alt=""
                                  width={"50px"}
                                  height="auto"
                                  style={{
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                  }}
                                />
                              </Box>
                              <Typography
                                sx={{
                                  ...FilterTextStyleOne,
                                  fontSize: "9px",
                                  textAlign: "center",
                                  ml: 0,
                                  color: ProductLocationState.includes(res.text)
                                    ? "#445FD2"
                                    : "#B2BCCF",
                                }}
                              >
                                {res.text}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    </Paper>

                    {ProductLocationState?.length > 0 && (
                      <Paper
                        elevation={0}
                        sx={{
                          width: "80%",
                          bgcolor: "transparent",
                          mx: "auto",
                          boxShadow: "none",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            alignContent: "center",
                            mt: 2,
                            height: "30px",
                          }}
                        >
                          <Typography sx={{ ...FilterTitle, cursor: "default" }}>
                            Select City
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            width: "100%",
                            height: "50px",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            alignContent: "center",
                            maxWidth: "385px",
                            overflow: "auto",
                            "::-webkit-scrollbar": {
                              display: "flex",
                              height: "6px",
                            },
                            gap: "10px",
                            mt: 0,
                            cursor: "pointer",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              minWidth: "310px",
                              gap: "10px"
                            }}
                          >

                            <Autocomplete
                              options={filteredCities}
                              getOptionLabel={(option) => option}
                              value={searchQuery}
                              onChange={(event, newValue) => {
                                setCity(newValue || "");
                                setSearchQuery(newValue)
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Search City..."
                                  variant="outlined"
                                  onChange={(e) => setSearchQuery(e.target.value)}
                                />
                              )}
                              sx={{
                                width: "100%",
                                maxWidth: "400px",
                              }}
                            />
                          </Box>
                        </Box>
                      </Paper>
                    )}

                  </>)}


                  <Paper
                    elevation={0}
                    sx={{
                      width: "80%",
                      bgcolor: "transparent",
                      mx: "auto",
                      boxShadow: "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        alignContent: "center",
                        mt: 0,
                        height: "50px",
                      }}
                    >
                      <Typography sx={FilterTitle}>Price Range</Typography>
                      <Typography
                        sx={{
                          ...FilterTitle,
                          fontSize: "12px",
                          lineHeight: "10px",
                        }}
                      >
                        <Box
                          component="img"
                          sx={{ width: "12px", height: "12px", mr: "1px" }}
                          src={BXIToken}
                        />
                        <CommaSeparator Price={pricerange} />
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        width: "auto",
                        height: "60px",
                        alignItems: "center",
                        alignContent: "center",
                        maxWidth: "385px",
                        overflowX: "scroll",
                        gap: "10px",
                        "&::-webkit-scrollbar": {
                          display: "none",
                        },
                        px: 2,
                        mt: 1,
                        bgcolor: "#E0F0FF",
                        borderRadius: "10px",
                      }}
                    >
                      <Slider
                        value={pricerange}
                        aria-label="Small steps"
                        size="small"
                        step={100000}
                        min={0}
                        max={1000000}
                        onChange={(event, newValue) => setPriceRange(newValue)} // Correct event handling
                      />

                    </Box>


                  </Paper>

                  <Paper
                    elevation={0}
                    sx={{
                      width: "80%",
                      bgcolor: "transparent",
                      mx: "auto",
                      boxShadow: "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        alignContent: "center",
                        mt: 2,
                        height: "auto",
                      }}
                    >
                      <Typography sx={{ ...FilterTitle, cursor: "default" }}>
                        Company Name
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        height: "60px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        alignContent: "center",
                        mt: 0,
                        borderRadius: "10px",
                      }}
                    >
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        sx={{
                          width: "100%",
                          height: "52px",
                          background: "#F8FAFB",
                          borderRadius: "10px",
                          border: "none",
                        }}
                        options={
                          Array?.from(
                            new Set(
                              allProductSearch?.map(
                                (option) => option?.companyName || ""
                              )
                            )
                          ) || []
                        }
                        value={selectedCompany}
                        onChange={handleSearch}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Company"
                            sx={{
                              width: "100%",
                              height: "52px",
                              background: "#F8FAFB",
                              borderRadius: "10px",
                              "& fieldset": { border: "none" },
                              color: "#445FD2",
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Paper>

                  <Paper
                    elevation={0}
                    sx={{
                      width: "80%",
                      bgcolor: "transparent",
                      mx: "auto",
                      boxShadow: "none",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: "100px",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        alignContent: "center",
                        mt: 0,
                        borderRadius: "10px",
                      }}
                    >
                      <Button
                        value="reset"
                        variant="outlined"
                        onClick={
                          handleClearFilter
                        }
                        sx={{
                          width: "200px",
                          height: "42px",
                          borderRadius: "6px",
                          fontFamily: "Poppins",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: "13px",
                          lineHeight: "20px",
                          textAlign: "center",
                          color: "#0053ad",
                          textTransform: "none",
                        }}
                      >
                        Clear Filter
                      </Button>
                    </Box>
                  </Paper>
                </Box>
              </Modal>
            </Box>
            <Box
              sx={{
                width: "20%",
                height: "45px",
                display: "flex",
                justifyContent: "space-between",
                alignContent: "center",
                alignItems: "center",
                borderRadius: "25px",
                boxShadow: "#2261a2 0px 0px 0px 0.5px;",
                px: "15px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                  color: "#2261a2",
                  fontWeight: 500,
                }}
              >
                Display with taxes
              </Typography>
              <label class="switch">
                <input type="checkbox" checked={taxSwitch} onChange={handleSwitch} />
                <span class="slider"></span>
              </label>
            </Box>
          </Box>
        </Paper >
      </Box >
      <Grid container sx={{ width: "97%", mx: "auto", mt: "35px", }}>
        <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={10.5}
          xs={10}
          sx={{
            bgcolor: "#f3f6f9",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <ProductDetailsCarousel onSendData={handleCarouselData} all={all} clear={clear} />
        </Grid>
      </Grid>

      <ImagePoster />
      <Paper
        elevation={0}
        sx={{ width: "100%", mx: "auto", background: "transparent" }}
      ><Grid container>

          {productdataLoading ? (
            [...Array(32)].map((e, i) => (
              <Grid
                item
                xl={3}
                lg={3}
                md={4}
                sm={6}
                xs={6}
                key={i}
                sx={GridCssOne}
              >
                <Paper elevation={0} sx={GridPaper}>
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      width: "100%",
                      maxWidth: "350px",
                      minHeight: {
                        xl: "360px",
                        lg: "360px",
                        md: "360px",
                        sm: "180px",
                        xs: "180px",
                      },
                      borderRadius: "15px",
                    }}
                  />
                </Paper>
              </Grid>
            ))
          ) : (

            AllProducts && AllProducts?.length > 0 ? (
              AllProducts?.map((res, idx) => {
                const discountPrice = Number(
                  res?.ProductsVariantions[0]?.DiscountedPrice
                );
                const percentage = Number(res?.ProductsVariantions[0]?.GST);
                const gstPrice = (discountPrice * percentage) / 100;
                const gstamount = discountPrice + gstPrice;

                const isAllOutOfStock = res?.ProductsVariantions.every(
                  (variation) =>
                    variation.MaxOrderQuantity < variation.MinOrderQuantity ||
                    variation.MaxOrderQuantity === 0
                );

                return (
                  <Grid
                    item
                    xl={3}
                    lg={4}
                    md={4}
                    sm={6}
                    xs={12}
                    key={idx}
                  >
                    <Box sx={ArrayBoxCss}>
                      <Box sx={ArrayBoxChild}>
                        <Box sx={ArrayBoxAbsolute}>
                          <Box sx={ArrayBoxAbsoluteChild}>
                            {(IsReadyStockflatIdsArray?.includes(`${res._id}`) ||
                              res?.IsReadyStock) &&
                              !isAllOutOfStock ? (
                              <img
                                src={readystock}
                                alt=""
                                style={{
                                  height: "auto",
                                  width: "38px",
                                }}
                              />
                            ) : null}
                            {res?.IsBestSeller ? (
                              <img
                                src={bestseller}
                                alt=""
                                style={{
                                  height: "auto",
                                  width: "38px",
                                }}
                              />
                            ) : null}
                          </Box>
                        </Box>
                        <Box sx={{ position: "relative" }}>
                          <Box
                            sx={ArrayBoxBoxRelative}
                          >
                            <Box
                              component={"img"}
                              src={
                                res?.ProductImages.length > 0
                                  ? res?.ProductImages[0].url
                                  : res?.VoucherImages?.at(0).url
                              }
                              alt="img"
                              sx={ArrayImageBox}
                            />
                            {res?.ListingType !== "Media" && isAllOutOfStock ? (
                              <Box sx={OutOfStock}>
                                <Button sx={OutOfBoxButton}>OUT OF STOCK</Button>
                              </Box>
                            ) : null}
                          </Box>
                        </Box>
                        <Box
                          sx={MainProductBox}

                        >
                          <Paper
                            sx={MainProductPaper}

                            elevation={0}
                          >
                            <Typography
                              sx={{
                                ...MainTextStyle,
                                display: "-webkit-box",
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                mt: "10px",
                              }}
                            >
                              {res?.ProductName}
                            </Typography>
                          </Paper>
                          <Paper
                            sx={StartingFromPaper}

                            elevation={0}
                          >
                            {res?.ProductsVariantions?.length > 1 ? (
                              <Typography
                                sx={{
                                  ...PriceTextStyle,
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                  alignContent: "center",
                                }}
                              >
                                Starting from
                              </Typography>
                            ) : null}
                            <Typography
                              sx={{
                                ...PriceTextStyle,
                                display: "flex",
                                gap: "5px",
                                alignItems: "center",
                                alignContent: "center",
                                height: "50px",
                              }}
                            >
                              {taxSwitch ? (
                                <>
                                  <Typography
                                    sx={{
                                      color: "#2261A2",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      display: "flex",
                                      alignContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Box
                                      component={"img"}
                                      src={StacsOfCoinIcon}
                                      sx={{
                                        width: {
                                          xl: "18px",
                                          lg: "18px",
                                          md: "18px",
                                          sm: "12px",
                                          xs: "12px",
                                        },
                                        height: "auto",
                                      }}
                                      alt="coin"
                                    />{" "}
                                  </Typography>

                                  {DiscountedPrice(
                                    res?.ProductsVariantions[0]?.DiscountedPrice,
                                    Number(res?.ProductsVariantions[0]?.GST),
                                    res?.ListingType
                                  )}
                                  <Typography
                                    sx={{
                                      fontFamily: "Poppins",
                                      fontStyle: "normal",
                                      fontWeight: 600,
                                      fontSize: "14px",
                                      letterSpacing: "0.06em",
                                      textTransform: "capitalize",
                                      color: "#2261A2",
                                      minWidth: "100px",
                                      display: "flex",
                                      gap: "5px",
                                      ml: "1px",
                                    }}
                                  >
                                    + ₹
                                    {res?.ListingType !== "Media"
                                      ? GstWithoutDiscountedPrice({
                                        price:
                                          res?.ProductsVariantions?.at(0)
                                            ?.DiscountedPrice,
                                        gst: Number(
                                          res?.ProductsVariantions?.at(0)?.GST
                                        ),
                                        listing: res?.ListingType,
                                      })
                                      : MediaGstWithoutDiscountedPrice({
                                        price:
                                          res?.mediaVariation?.DiscountedPrice,
                                        gst: Number(res?.mediaVariation?.GST),
                                        listing: res?.ListingType,
                                      })}
                                  </Typography>
                                </>
                              ) : (
                                <>
                                  <Typography
                                    sx={{
                                      color: "#2261A2",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      display: "flex",
                                      alignContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <DiscountPrice
                                      regularPrice={
                                        res?.ProductsVariantions[0]?.PricePerUnit
                                      }
                                      discountPrice={
                                        res?.ProductsVariantions[0]
                                          ?.DiscountedPrice
                                      }
                                    />
                                  </Typography>
                                </>
                              )}
                            </Typography>
                          </Paper>
                          <Paper
                            sx={{
                              ...ProductDescPaper,
                              minHeight:
                                res?.ProductDescription.length >= 33
                                  ? "33px"
                                  : "34px",
                            }}
                            elevation={0}
                          >
                            <Typography sx={BottomTextStyle}>
                              {res?.ProductDescription
                                ? res?.ProductDescription
                                : ""}
                            </Typography>
                          </Paper>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                );
              })
            ) : (
              <Box
                sx={{
                  mx: "auto",
                  gap: "20px",
                  width: "100%",
                  mt: 2,
                  display: "grid",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <Box
                  component="img"
                  src={Nodataimgur}
                  sx={{
                    width: "auto",
                    maxWidth: "250px",
                    height: "auto",
                    mx: "auto",
                  }}
                />
                <Typography
                  sx={{
                    ...EmptyWishlistTextOne,
                    lineHeight: "20px",
                  }}
                >
                  No Data Found!
                  <span style={{ fontWeight: 400, fontSize: "12px" }}>
                    Sorry .. This information is not available for a moment.
                  </span>
                </Typography>
              </Box>
            )
          )}
        </Grid>
      </Paper>
      {
        AllProducts && AllProducts?.length > 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: {
                xl: "100%",
                lg: "100%",
                md: "100%",
                sm: "100%",
                xs: "100%",
              },
              mx: "auto",
            }}
            mt={2}
          >
            <Stack>
              <StyledPagination
                size="medium"
                count={initialPaginationCount}
                color="primary"
                page={currentPage}
                onChange={handlePageChange}
                strokeWidth={currentPage}
              />
            </Stack>
          </Box>
        ) : null
      }
      <TostMessagesTop PageLocation="Marketplace" />

      <Dialog open={showPopup} fullWidth maxWidth="sm">
        <DialogTitle>
          <Typography sx={TitleText}>Schedule a Demo</Typography>
          <Typography sx={TitleChildText}>Choose a time that works for you</Typography>
        </DialogTitle>

        <DialogContent>
          <TextField
            label="Name"
            name="name"
            fullWidth
            margin="dense"
            value={formData.name}
            onChange={handleChangeFormdata}
            error={!!errors.name}
            helperText={errors.name}
            InputLabelProps={{
              shrink: true,
              sx: {
                fontSize: '14px',
              },
            }}
            InputProps={{
              sx: {
                fontSize: '14px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '2px',
                },
                paddingY: "0px",
                height: "45px"
              },
            }}
            sx={{ mt: 2 }}
          />
          <TextField
            label="Company"
            name="company"
            fullWidth
            margin="dense"
            value={formData.company}
            onChange={handleChangeFormdata}
            error={!!errors.company}
            helperText={errors.company}
            InputLabelProps={{
              shrink: true,
              sx: {
                fontSize: '14px',
              },
            }}
            InputProps={{
              sx: {
                fontSize: '14px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '2px',
                },
                paddingY: "0px",
                height: "45px"
              },
            }}
            sx={{ mt: 2 }}
          />
          <TextField
            label="Business Email"
            name="email"
            fullWidth
            margin="dense"
            value={formData.email}
            onChange={handleChangeFormdata}
            error={!!errors.email}
            helperText={errors.email}
            InputLabelProps={{
              shrink: true,
              sx: {
                fontSize: '14px',
              },
            }}
            InputProps={{
              sx: {
                fontSize: '14px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '2px',
                },
                paddingY: "0px",
                height: "45px"
              },
            }}
            sx={{ mt: 2 }}
          />
          <TextField
            label="Phone"
            name="phone"
            fullWidth
            margin="dense"
            value={formData.phone}
            onChange={handleChangeFormdata}
            error={!!errors.phone}
            helperText={errors.phone}
            InputLabelProps={{
              shrink: true,
              sx: {
                fontSize: '16px',
              },
            }}
            InputProps={{
              sx: {
                fontSize: '16px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '2px',
                },
                paddingY: "0px",
                height: "45px"
              },
            }}
            sx={{ mt: 2 }}

          />

          <Box mt={2}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Block a date"
                disablePast
                value={selectedDate}
                onChange={(newDate) => setSelectedDate(newDate)}
                shouldDisableDate={(date) => {
                  const formatted = format(date, 'yyyy-MM-dd');
                  return isSunday(date) || holidays.includes(formatted);
                }}
                slotProps={{
                  textField: {
                    fullWidth: false,
                    variant: 'outlined',
                    InputLabelProps: {
                      shrink: true,
                    },
                    sx: {
                      '& .MuiInputBase-input': {
                        fontSize: '13px',
                        padding: '15.5px 14px',
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '18px',
                        backgroundColor: 'white',
                        padding: '0 4px',
                        left: '0px',
                      },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderWidth: '2px',
                        },
                      },
                      paddingY: "0px",
                      height: "45px"
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Box>

          <Box mt={2}>
            <Typography sx={SlotTextStyle}>Available Slots</Typography>
            {loadingSlots ? (
              <></>
            ) : (
              <Grid container spacing={1} mt={1}>
                {availableSlots.map((slot) => {
                  console.log("ldskhfguisdfds", slot)
                  return (
                    <Grid item key={slot}>
                      <Button
                        onClick={() => setSelectedSlot(slot)}
                        size="small"
                        sx={{
                          color: selectedSlot === slot ? "#fff" : "#2261a2",
                          border: "1px solid #2261a2",
                          color: selectedSlot === slot ? "#fff" : "#2261a2",
                          background: selectedSlot === slot ? "#2261a2" : "#fff",
                          '&:hover': {
                            background: "#2261a2",
                            color: "#fff",
                            border: "1px solid #2261a2"
                          }
                        }}
                      >
                        <Typography sx={TimeSlotText}>
                          {new Date(slot).toLocaleTimeString('en-IN', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true,
                            timeZone: 'Asia/Kolkata'
                          })}
                        </Typography>

                      </Button>
                    </Grid>
                  )
                })}
                {availableSlots.length === 0 && <Typography sx={SlotTextStyle}>No slots available</Typography>}
              </Grid>
            )}
            {errors.slot && <Typography color="error">{errors.slot}</Typography>}
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleSubmit} sx={BookDemoButtonStyle}>Book Demo</Button>
        </DialogActions>
      </Dialog>
    </Paper >
  );
};

export default MarketPlace;

const BottomTextStyle = {
  width: "90%",
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: {
    xl: "11px",
    lg: "11px",
    md: "8px",
    sm: "8px",
    xs: "8px",
  },
  lineHeight: "15px",
  color: "#6B7A99",
  textAlign: "left",
  mt: 0.5,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const GridCssOne = {
  boxSizing: "border-box",
  width: "100%",
  height: "auto",
  maxWidth: "350px",
  minHeight: {
    xl: "360px",
    lg: "360px",
    md: "360px",
    sm: "180px",
    xs: "180px",
  },
  my: "20px",
  borderRadius: "13.6px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const GridPaper = {
  width: "100%",
  mx: "auto",
  height: "100%",
  bgcolor: "#fff",
  borderRadius: "13px",
  padding: "0px",
  maxWidth: "350px",
  minHeight: {
    xl: "360px",
    lg: "360px",
    md: "360px",
    sm: "180px",
    xs: "180px",
  },
};



const EmptyWishlistTextOne = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  textAlign: "center",
  color: "#7E8BA6",
  display: "flex",
  flexDirection: "column",
};

const ArrayBoxCss = {
  mx: "auto",
  boxSizing: "border-box",
  width: "100%",
  height: "auto",
  maxWidth: {
    xl: "340px",
    lg: "330px",
    md: "300px",
    sm: "280px",
    xs: "310px",
  },
  minHeight: {
    xl: "360px",
    lg: "360px",
    md: "360px",
    sm: "340px",
    xs: "340px",
  },
  bgcolor: "red",
  borderRadius: "13.6px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  my: "20px",
  cursor: "pointer",
  border: "0.1px solid transparent",
  backgroundImage:
    "linear-gradient(180deg,#2261a2 0%,#2261a2 47.4%,#2261a2 100%)",
  transition: "box-shadow .1s",
  "&:hover": {
    boxShadow: "0px 0px 17px #ff864547",
  },
};

const ArrayBoxChild = {
  width: "100%",
  mx: "auto",
  height: "100%",
  bgcolor: "#fff",
  borderRadius: "13px",
  padding: "0px",
  minHeight: {
    xl: "360px",
    lg: "360px",
    md: "360px",
    sm: "360px",
    xs: "360px",
  },
  position: "relative",
};

const ArrayBoxAbsolute = {
  display: "flex",
  position: "relative",
  position: "absolute",
  width: "100%",
  top: "0px",
};

const ArrayBoxAbsoluteChild = {
  left: "2%",
  top: "-5%",
  position: "absolute",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "6px",
};

const ArrayBoxBoxRelative = {
  width: "100%",
  height: "auto",
  minHeight: {
    xl: "160px",
    lg: "160px",
    md: "160px",
    sm: "100px",
    xs: "100px",
  },
  mx: "auto",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  cursor: "pointer",
  position: "absolute",
  top: "40px",
};

const ArrayImageBox = {
  width: "auto",
  maxWidth: {
    xl: "300px",
    lg: "270px",
    md: "270px",
    sm: "130px",
    xs: "130px",
  },
  maxHeight: {
    xl: "200px",
    lg: "200px",
    md: "130px",
    sm: "80px",
    xs: "80px",
  },
  height: "auto",
  marginLeft: "auto",
  marginRight: "auto",
  borderRadius: {
    xl: "10px",
    lg: "10px",
    md: "10px",
    sm: "5px",
    xs: "5px",
  },
};

const OutOfStock = {
  background: "rgba(129, 129, 129, 0.47)",
  backdropFilter: "blur(5.599999904632568px)",
  position: "absolute",
  width: "100%",
  maxWidth: "350px",
  maxHeight: "60px",
  height: "100%",
  marginLeft: "auto",
  marginRight: "auto",
  borderRadius: "0px",
  top: "50%",
};

const OutOfBoxButton = {
  color: "#FFF",
  fontFamily: "Poppins",
  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "normal",
  textTransform: "uppercase",
  textAlign: "center",
  width: "100%",
  height: "100%",
};

const MainProductBox = {
  width: "100%",
  mx: "auto",
  height: "auto",
  display: "grid",
  justifyContent: "center",
  alignItems: "center",
  pb: 2,
  cursor: "pointer",
  mt: 1,
  minWidth: {
    xl: "350px",
    lg: "350px",
    md: "350px",
    sm: "250px",
    xs: "250px",
  },
  position: "absolute",
  top: "auto",
  bottom: "-0px",
};

const MainProductPaper = {
  width: "97%",
  mx: "auto",
  height: "auto",
  minWidth: {
    xl: "275px",
    lg: "275px",
    md: "275px",
    sm: "140px",
    xs: "140px",
  },
  maxWidth: {
    xl: "275px",
    lg: "275px",
    md: "275px",
    sm: "150px",
    xs: "150px",
  },
  display: "flex",
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
};

const StartingFromPaper = {
  width: "97%",
  mx: "auto",
  height: "auto",
  minWidth: {
    xl: "275px",
    lg: "275px",
    md: "275px",
    sm: "140px",
    xs: "140px",
  },
  maxWidth: {
    xl: "275px",
    lg: "275px",
    md: "275px",
    sm: "150px",
    xs: "150px",
  },
  display: "flex",
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
};

const ProductDescPaper = {
  width: "97%",
  mx: "auto",
  minWidth: {
    xl: "275px",
    lg: "275px",
    md: "275px",
    sm: "140px",
    xs: "140px",
  },
  maxWidth: {
    xl: "275px",
    lg: "275px",
    md: "275px",
    sm: "150px",
    xs: "150px",
  },
};


const MainTextStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: { xl: "16px", lg: "16px", md: "14px", sm: "10px", xs: "10px" },
  color: "#141414",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  maxWidth: "320px",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const PriceTextStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: { xl: "15px", lg: "15px", md: "15px", sm: "10px", xs: "10px" },
  lineHeight: "24px",
  color: "#717171",
};

const FilterModalStyle = {
  position: "absolute",
  width: "90%",
  maxWidth: { xl: "430px", lg: "430px", md: "430px", sm: "400px", xs: "350px" },
  height: "100%",
  right: "5%",
  top: "04%",
  maxHeight: "60vh",
  overflowY: "scroll",
  background: "#FFFFFF",
  borderRadius: "10px",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

const FilterTitle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "28px",

  color: "#2E2E2E",
};

const FilterTextStyleOne = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  color: "#B2BCCF",
  ml: 1.5,
};

const TitleText = {
  fontFamily: "Poppins",
  fontSize: "16px",
  fontWeight: "normal",
}

const TitleChildText = {
  fontFamily: "Poppins",
  fontSize: "12px",
  fontWeight: "normal",
}


const SlotTextStyle = {
  fontFamily: "Poppins",
  fontSize: "14px"
}

const TimeSlotText = {
  fontFamily: "Poppins",
  fontSize: "12px"
}

const BookDemoButtonStyle = {
  width: "100%",
  height: "38px",
  textTransform: "none",
  fontFamily: "Poppins",
  fontSize: "14px",
  background: "#2261a2",
  color: "#fff",
  border: "1px solid #2261a2",
  '&:hover': {
    background: "#fff",
    color: "#2261a2",
    border: "1px solid #2261a2",
  }
}